import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export function createStore(route) {
  const actions = {
    isLoading: ctx => {
      ctx.commit('getLoadingStatus')
    },
    loadingStatus: (ctx, status) => {
      ctx.commit('updateLoadingStatus', status)
    }
  }

  const mutations = {
    updateLoadingStatus: (state, status) => {
      state.loading = status
    },
    updateHeaderText: (state, text) => {
      state.headerText = text
    }
  }
  const getters = {
    getLoadingStatus: state => {
      state.loading
    },
    getHeaderText: state => {
      state.headerText
    }
  }

  return new Vuex.Store({
    state: {
      loading: true,
      headerText: 'Pemerintah Provinsi DKI Jakarta',
    },
    actions,
    mutations,
    getters
  })
}
